import React, { Component, useRef } from 'react';
import * as ReactDOM from "react-dom";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useEffect } from "react";
import { settoken } from "../features/WhiseTokenSlice";
import { useSelector, useDispatch } from "react-redux";
import { useState } from 'react';
import axios from 'axios';
import { Datepicker, DatepickerEvent } from "@meinefinsternis/react-horizontal-date-picker";
import { EventModal } from "./EventModal";
import { variables } from '../Variables';
import { clearMailVerificationDetail } from "../features/EmailVerificationSlice";
import { Footer } from './Footer'

import propMainImg from '../assets/images/Rectangle_68.png';
import locationPin from '../assets/images/location_pin.svg';
import phone from '../assets/images/phone.svg';
import bed from '../assets/images/bed.svg';
import p_shower from '../assets/images/p_shower.svg';
import lift from '../assets/images/lift.svg';
import megaphone from '../assets/images/megaphone.svg';
import closeIcon from '../assets/images/cross-close.svg';
import languageDropdownIcon from '../assets/images/language-icon.svg';
import websiteIcon from '../assets/images/website_img.svg';
import angleLeft from '../assets/images/angle-left-small_black.svg';
import angleRight from '../assets/images/angle-right-small_black.svg';
import alertSpeaker from '../assets/images/alert-speaker.svg';
import errorMessage from '../assets/images/error-message.svg';
import deactiveAlert from '../assets/images/deactive-alert.svg';
import mindFreeLogo from '../assets/images/Mindfree_Logo.svg';
import { deletWhiseEventBookingService, getEstateAndOfficeSetting, getIpAddress, queryParamObj } from '../utils/commonService';
import { getUserAccountType } from '../utils/whiseApiService';
import { getEstateJobStatus } from '../utils/estateService';
import { LockOverlayUI } from '../ui/LockOverlayUI';

const localeMapping = {
    "en-GB": "en-GB", "fr-BE": "fr", "nl-BE": "nl-BE", "zu-ZA": "", "zh-Hant-TW": "", "zh-Hans-SG": "", "zh-Hans-MO": "", "zh-Hans-HK": "", "zh-Hans-CN": "", "zgh-MA": "", "yo-NG": "",
    "yo-BJ": "", "xh-ZA": "", "wo-SN": "", "vi-VN": "", "uz-Latn-UZ": "", "uz-Cyrl-UZ": "", "ur-PK": "", "ur-IN": "", "uk-UA": "", "ug-CN": "", "tt-RU": "", "tr-TR": "", "tr-CY": "", "tk-TM": "",
    "ti-ET": "", "ti-ER": "", "th-TH": "", "tg-TJ": "", "te-IN": "", "ta-SG": "", "ta-MY": "", "ta-LK": "", "ta-IN": "", "sw-UG": "", "sw-TZ": "", "sw-KE": "", "sw-CD": "", "sv-SE": "", "sv-FI": "",
    "sr-Latn-XK": "", "sr-Latn-RS": "", "sr-Latn-ME": "", "sr-Latn-BA": "", "sr-Cyrl-XK": "", "sr-Cyrl-RS": "", "sr-Cyrl-ME": "", "sr-Cyrl-BA": "", "sq-XK": "", "sq-MK": "", "sq-AL": "", "so-SO": "",
    "so-KE": "", "so-ET": "", "so-DJ": "", "sn-ZW": "", "sl-SI": "", "sk-SK": "", "si-LK": "", "se-SE": "", "se-NO": "", "se-FI": "", "sd-PK": "", "sah-RU": "", "ru-UA": "", "ru-RU": "", "ru-MD": "",
    "ru-KZ": "", "ru-KG": "", "ru-BY": "", "ro-RO": "", "ro-MD": "", "rm-CH": "", "pt-TL": "", "pt-ST": "", "pt-PT": "", "pt-MZ": "", "pt-MO": "", "pt-LU": "", "pt-GW": "", "pt-GQ": "", "pt-CV": "",
    "pt-CH": "", "pt-BR": "", "pt-AO": "", "ps-PK": "", "ps-AF": "", "pl-PL": "", "pa-Guru-IN": "", "pa-Arab-PK": "", "or-IN": "", "om-KE": "", "om-ET": "", "nn-NO": "", "nl-SX": "", "nl-SR": "",
    "nl-NL": "", "nl-CW": "", "nl-BQ": "", "nl-AW": "", "ne-NP": "", "ne-IN": "", "nb-SJ": "", "nb-NO": "", "my-MM": "", "mt-MT": "", "ms-SG": "", "ms-MY": "", "ms-BN": "", "mr-IN": "", "mn-MN": "",
    "ml-IN": "", "mk-MK": "", "mi-NZ": "", "mg-MG": "", "lv-LV": "", "lt-LT": "", "lb-LU": "", "ku-TR": "", "kok-IN": "", "ko-KR": "", "ko-KP": "", "kn-IN": "", "km-KH": "", "kk-KZ": "", "ka-GE": "",
    "jv-ID": "", "ja-JP": "", "it-IT": "", "it-CH": "", "is-IS": "", "ii-CN": "", "ig-NG": "", "id-ID": "", "hy-AM": "", "hu-HU": "", "hsb-DE": "", "hr-HR": "", "hi-IN": "", "he-IL": "", "gu-IN": "",
    "gsw-CH": "", "gl-ES": "", "gd-GB": "", "ga-IE": "", "fy-NL": "", "fr-YT": "", "fr-WF": "", "fr-VU": "", "fr-TN": "", "fr-TG": "", "fr-TD": "", "fr-SY": "", "fr-SN": "", "fr-SC": "", "fr-RW": "",
    "fr-RE": "", "fr-PM": "", "fr-PF": "", "fr-NE": "", "fr-NC": "", "fr-MU": "", "fr-MR": "", "fr-MQ": "", "fr-ML": "", "fr-MG": "", "fr-MF": "", "fr-MC": "", "fr-MA": "", "fr-LU": "", "fr-KM": "",
    "fr-HT": "", "fr-GQ": "", "fr-GP": "", "fr-GN": "", "fr-GF": "", "fr-GA": "", "fr-FR": "", "fr-DZ": "", "fr-DJ": "", "fr-CM": "", "fr-CI": "", "fr-CH": "", "fr-CG": "", "fr-CF": "", "fr-CD": "",
    "fr-CA": "", "fr-BL": "", "fr-BJ": "", "fr-BI": "", "fr-BF": "", "fo-FO": "", "fo-DK": "", "fil-PH": "", "fi-FI": "", "fa-IR": "", "fa-AF": "", "eu-ES": "", "et-EE": "", "es-VE": "", "es-UY": "",
    "es-US": "", "es-SV": "", "es-PY": "", "es-PR": "", "es-PH": "", "es-PE": "", "es-PA": "", "es-NI": "", "es-MX": "", "es-IC": "", "es-HN": "", "es-GT": "", "es-GQ": "", "es-ES": "", "es-EC": "",
    "es-EA": "", "es-DO": "", "es-CU": "", "es-CR": "", "es-CO": "", "es-CL": "", "es-BZ": "", "es-BR": "", "es-BO": "", "es-AR": "", "en-ZW": "", "en-ZM": "", "en-ZA": "", "en-WS": "", "en-VU": "",
    "en-VI": "", "en-VG": "", "en-VC": "", "en-US": "", "en-UM": "", "en-UG": "", "en-TZ": "", "en-TV": "", "en-TT": "", "en-TO": "", "en-TK": "", "en-TC": "", "en-SZ": "", "en-SX": "", "en-SS": "",
    "en-SL": "", "en-SI": "", "en-SH": "", "en-SG": "", "en-SE": "", "en-SD": "", "en-SC": "", "en-SB": "", "en-RW": "", "en-PW": "", "en-PR": "", "en-PN": "", "en-PK": "", "en-PH": "", "en-PG": "",
    "en-NZ": "", "en-NU": "", "en-NR": "", "en-NL": "", "en-NG": "", "en-NF": "", "en-NA": "", "en-MY": "", "en-MW": "", "en-MU": "", "en-MT": "", "en-MS": "", "en-MP": "", "en-MO": "", "en-MH": "",
    "en-MG": "", "en-LS": "", "en-LR": "", "en-LC": "", "en-KY": "", "en-KN": "", "en-KI": "", "en-KE": "", "en-JM": "", "en-JE": "", "en-IO": "", "en-IN": "", "en-IM": "", "en-IL": "", "en-IE": "",
    "en-HK": "", "en-GY": "", "en-GU": "", "en-GM": "", "en-GI": "", "en-GH": "", "en-GG": "", "en-GD": "", "en-FM": "", "en-FK": "", "en-FJ": "", "en-FI": "", "en-ER": "", "en-DM": "", "en-DK": "",
    "en-DE": "", "en-CY": "", "en-CX": "", "en-CM": "", "en-CK": "", "en-CH": "", "en-CC": "", "en-CA": "", "en-BZ": "", "en-BW": "", "en-BS": "", "en-BM": "", "en-BI": "", "en-BE": "", "en-BB": "",
    "en-AU": "", "en-AT": "", "en-AS": "", "en-AI": "", "en-AG": "", "en-AE": "", "el-GR": "", "el-CY": "", "de-LU": "", "de-LI": "", "de-IT": "", "de-DE": "", "de-CH": "", "de-BE": "", "de-AT": "",
    "da-GL": "", "da-DK": "", "cy-GB": "", "cs-CZ": "", "ca-ES": "", "br-FR": "", "bo-IN": "", "bo-CN": "", "bn-IN": "", "bn-BD": "", "bg-BG": "", "be-BY": "", "as-IN": "", "ar-YE": "", "ar-TN": "",
    "ar-TD": "", "ar-SY": "", "ar-SS": "", "ar-SO": "", "ar-SD": "", "ar-SA": "", "ar-QA": "", "ar-PS": "", "ar-OM": "", "ar-MR": "", "ar-MA": "", "ar-LY": "", "ar-LB": "", "ar-KW": "", "ar-KM": "",
    "ar-JO": "", "ar-IQ": "", "ar-IL": "", "ar-ER": "", "ar-EH": "", "ar-EG": "", "ar-DZ": "", "ar-DJ": "", "ar-BH": "", "ar-AE": "", "am-ET": "", "af-ZA": "", "af-NA": "",
};

// Shared month mapping with correct accents and normalization helper
const monthMappingsFixed = {
    "en-GB": ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"],
    "fr-BE": ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
    "nl-BE": ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
};
const normalizeForClass = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

const monthNamesForTranslationKeys = ["january", "february", "march", "april", "may", "june",
    "july", "august", "september", "october", "november", "december"
];


export const Home = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 991);
    const ref = useRef(null);
    const [calendarActions, setCalendarActions] = useState([]);
    const [clientEstates, setClientEstates] = useState([]);
    const [selectedEstate, setSelectedEstate] = useState(null);
    const [whiseCalendarEvents, setWhiseCalendarEvents] = useState([]);
    const [clientToken, setClientToken] = useState("");
    const [confirmedIds, setConfirmedIds] = useState([]);
    const [tobeConfirmedIds, setTobeConfirmedIds] = useState([]);
    const [freeSlotIds, setFreeSlotIds] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [showBookedSlots, setShowBookedSlots] = useState(false); // client setting: show booked slots (grey, not selectable)
    const [showModal, setShowModal] = useState(false);
    const [clientSettings, setClientSettings] = useState(null);
    const [whiseOffice, setWhiseOffice] = useState(null);
    const [xCoordinate, setXCoordinate] = useState("");
    const [yCoordinate, setYCoordinate] = useState("");
    const [mapUrl, setMapUrl] = useState("");
    const [time, setTime] = useState("");
    const [estatePurpose, setEstatePurpose] = useState(null);
    const [formStep, setFormStep] = useState(1);
    const [prevSelectedEventSlot, setPrevSelectedEventSlot] = useState(null);
    const [announcementMessage, setAnnouncementMessage] = useState("");
    const [locale, setLocale] = useState(null);
    const [showButtonLoader, setShowButtonLoader] = useState(false);
    const [bookableUntilType, setBookableUntilType] = useState(null);
    const [bookableUntilValue, setBookableUntilValue] = useState(null);
    const [showLoader, setShowLoader] = useState(false);

    const [allLanguageForDropwon, setAllLanguageForDropwon] = useState([]);
    const [translationsForAllLanguages, setTranslationsForAllLanguages] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState("en-GB");
    const [selectedLanguageTranslations, setSelectedLanguageTranslations] = useState(null);
    const [agentLanguageTranslation, setAgentLanguageTranslation] = useState(null);
    const [slotAvailable, setSlotAvailable] = useState([]);
    const [officeLogoUrl, setOfficeLogoUrl] = useState("");
    const [officeSetting, setOfficeSetting] = useState(null);
    const [contactTitles, setContactTitles] = useState([]);
    const [formattedDate, setFormattedDate] = useState("");
    const [disableDates, setDisableDates] = useState([]);
    const [timeSlotUpdateLoader, setTimeSlotUpdateLoader] = useState(false);
    const [freeSlotNotAvailable, setFreeSlotNotAvailable] = useState(false);
    const [waitingListContactDetail, setWaitingListContactDetail] = useState(null);
    const [waitingListEnabled, setWaitingListEnabled] = useState(false);
    const [checkEstateStatusInDB, setCheckEstateStatusInDB] = useState("");
    const [getOfficeId, setGetOfficeId] = useState("");
    const [getClientId, setGetClientId] = useState("");
    const [funCallHistoryLog, setFunCallHistoryLog] = useState([]);
    const [estateInActiveInLocalDb, setEstateInActiveInLocalDb] = useState(false);
    const [getActiveLatestEstateIdInDB, setGetActiveLatestEstateIdInDB] = useState(null);
    const [isAutomaticSlotAccept, setIsAutomaticSlotAccept] = useState("");
    const [estateSubCategory, setEstateSubCategory] = useState("");
    const [estateJobStatus, setEstateJobStatus] = useState("");
    const [eventsLoaded, setEventsLoaded] = useState(false);


    let purpose = [{ "id": 1, "name": "for sale" }, { "id": 2, "name": "for rent" }, { "id": 3, "name": "life annuity sale" }];

    let startValueForDateSlider = new Date();
    let firstMatchFound = false;
    let eventExist = false;
    const defaultLanguage = "en-GB";
    const logHistoryShow = false;

    const [date, setDate] = useState(startValueForDateSlider);

    var days = ['sun', 'mon', 'tue', 'wed', 'thur', 'fri', 'sat'];

    //let { propertyId, clientId, officeId, contactId, languageId, iframe } = useParams();

    let { propertyId, clientId, officeId, contactId, languageId, iframe } = useParams();

    // detect if contactId is actually languageId (when missing)
    if (clientId && clientId.includes("-")) {
        languageId = clientId;
        iframe = officeId;
    } else if (contactId && contactId.includes("-") && iframe === undefined && languageId == "iframe") {
        languageId = contactId;
        contactId = "32065699"; // default contact
        iframe = "iframe";
    } else if (contactId && contactId.includes("-")) {
        languageId = contactId;
        contactId = "32065699"; // default contact
    }

    contactId = contactId || "32065699"; // dump contact

    // Get query string parameters
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const queryParams = Object.fromEntries(searchParams.entries()); // Convert to object
    const navigate = useNavigate();

    const whiseUserToken = useSelector(state => state.whiseUser.whiseToken);
    const dispatch = useDispatch();

    // 1: Get the browser's primary language 
    useEffect(() => {
        if (!languageId) {
            const browserLanguage = defaultLanguage; //navigator.language || navigator.userLanguage;
            //const browserLanguage = navigator.language || navigator.userLanguage;tLocale
            setSelectedLanguage(browserLanguage);
        }
        else {
            //setSelectedLanguage(languageId);
            setSelectedLanguage(normalizeLanguageId(languageId));
        }

        if (iframe == "iframe") {
            document.body.style.backgroundColor = iframe == "iframe" ? "transparent" : "";
        }

        setShowLoader(true);
    }, [languageId, iframe]);

    const normalizeLanguageId = (languageId) => {
        return languageId.substring(0, 2).toLowerCase() + '-' + languageId.substring(3, 5).toUpperCase();
    }

    // get active latest estate id from lcoal db
    const getActiveLatestEstateIdFromDB = async (propertyId) => {
        try {
            let url = `${variables.API_URL}Estate/GetEstateLatestId?inputEstateId=${propertyId}`;
            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);

            if (response.data) {
                //console.log(response.data);
                setGetActiveLatestEstateIdInDB(response.data);
                getClientIdAndOfficeIdBaseOnEstateId(response.data);

                if (response.data != propertyId) {
                    console.log("render latest estate id");
                    navigate(`/${response.data}`, { replace: true });
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    // get client id and office id base on estate id
    const getClientIdAndOfficeIdBaseOnEstateId = async (latestEstateId) => {
        try {
            let url = `${variables.API_URL}LocalEvents/GetPropertyStatusInternal?estateId=${latestEstateId}&key=9a82408f`;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };
            let response = await axios.get(url, config);
            if (response.data) {
                //console.log(response.data);
                setGetOfficeId(response.data.officeId);
                setGetClientId(response.data.clientId);

                let payload = {
                    clientId: response.data.clientId,
                    officeId: response.data.officeId,
                    estateId: latestEstateId,
                    actionType: "non-ui",
                    settingType: "estate"
                }

                getEstateAndOfficeSettingFromLocalDB(payload);
            }
        } catch (error) {
            console.log(error);
            setEstateInActiveInLocalDb(true);
        }
    }

    // get setting estate and office from local db
    const getEstateAndOfficeSettingFromLocalDB = async (payload) => {

        const getEstateAndOfficeSettingObj = await getEstateAndOfficeSetting(payload);
        //console.log(getEstateAndOfficeSettingObj);
        if (getEstateAndOfficeSettingObj != "error") {

            if (getEstateAndOfficeSettingObj.waitingListEnabled.toLowerCase() == "true") {
                setWaitingListEnabled(true);
            } else {
                setWaitingListEnabled(false);
            }

            setIsAutomaticSlotAccept(getEstateAndOfficeSettingObj.automaticSlotAcceptation.toLowerCase());

        } else {
            getOfficeSettings("errorApiInEstateAndOfficeSetting");
            console.log("error");
        }

    }

    useEffect(() => {
        if (propertyId) {
            getActiveLatestEstateIdFromDB(propertyId); // get latest estate id from local db
        }
    }, [propertyId]);

    // get free slots events from local db
    const getCalendarEventsFromDB = async () => {
        try {
            setShowLoader(true);
            // replace propertyId => getActiveLatestEstateIdInDB in url
            let url = `${variables.API_URL}LocalEvents/GetLocalEventsForBookingSiteWithADO?clientId=${getClientId}&officeId=${getOfficeId}&estateId=${getActiveLatestEstateIdInDB}`

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            let response = await axios.post(url, {}, config);

            let responseLocalDBEvents = response.data;

            if (responseLocalDBEvents.totalCount != undefined && responseLocalDBEvents.totalCount > 0) {
                //listOfEvents.push(...responseLocalDBEvents.calendars);
                //console.log("localEvent", responseLocalDBEvents.calendars[0]);
                let _date = new Date();
                const freeSlotEventFromDb = responseLocalDBEvents.calendars;

                //check if free slot events exist for selected day
                /*let SelectedDate = _date; //current date;
                let currentSelectedDateEvents = freeSlotEventFromDb.filter(item => {
                    return new Date(item.startDateTime).getDate() == SelectedDate.getDate() && new Date(item.startDateTime) >= SelectedDate;
                })
                setSlotAvailable(currentSelectedDateEvents);*/

                // booked = event action is confirmed / to-be-confirmed action (from office settings)
            const bookedActionIds = [...confirmedIds, ...tobeConfirmedIds].filter(id => id).map(Number);

            let sortedEvents = freeSlotEventFromDb.length > 0 ? freeSlotEventFromDb
                .map(event => ({ ...event, isBooked: bookedActionIds.includes(Number(event.action?.id)) }))
                .filter(event => new Date(event.startDateTime) >= _date)
                .sort((a, b) => new Date(a.startDateTime) - new Date(b.startDateTime) || (a.isBooked ? 1 : 0) - (b.isBooked ? 1 : 0)) : [];

                //let removeDuplicateFreeSlot = [...new Set(freeSlotIds)];
                //const freeSlotCalendarActionId = removeDuplicateFreeSlot[0];

                //console.log(sortedEvents);

                //const sortedEventsAfterFreeSlotFilter = sortedEvents.filter((item) => item.action.id == freeSlotCalendarActionId);

                //let targetDate = new Date(sortedEvents[0].startDateTime); // start time set from first event

                //// filter all events that match with first event start time & default preselect date
                //const dayEvents = sortedEvents.filter(ev => {
                //    const evDate = new Date(ev.startDateTime);
                //    return evDate.getDate() === targetDate.getDate() && evDate.getMonth() === targetDate.getMonth();
                //});

                //setDate(targetDate);
                //setSlotAvailable(dayEvents); // default slots show

                if (sortedEvents.length == 0) {
                    setShowLoader(false);
                    setFreeSlotNotAvailable(true);
                }
                else {

                    let targetDate = new Date((sortedEvents.find(ev => !ev.isBooked) || sortedEvents[0]).startDateTime); // first free slot day

                    // filter all events that match with first event start time & default preselect date
                    const dayEvents = sortedEvents.filter(ev => {
                        const evDate = new Date(ev.startDateTime);
                        return evDate.getDate() === targetDate.getDate() && evDate.getMonth() === targetDate.getMonth();
                    });

                    setDate(targetDate);
                    setSlotAvailable(dayEvents); // default slots show
                selectFirstFreeSlot(dayEvents); // preselect first available slot

                    setWhiseCalendarEvents(sortedEvents);
                    setShowLoader(false);

                    /* let firstEventDate = new Date(sortedEvents[0].startDateTime);
                     firstEventDate.setHours(0, 0, 0, 0);
                     const today = new Date();
                     today.setHours(0, 0, 0, 0);
                     const datesToDisable = [];
 
                     let current = new Date(today);
                     while (current < firstEventDate) {
                         datesToDisable.push(new Date(current));
                         current.setDate(current.getDate() + 1);
                     }
 
                     setDisableDates(datesToDisable);*/

                }
            }
            else {
                setFreeSlotNotAvailable(true);
                setWhiseCalendarEvents([]);
                setShowLoader(false);
            }

        } catch (error) {
            console.log(error);
        } finally {
            setEventsLoaded(true);
        }
    }

    useEffect(() => {
        // wait for office settings (confirmedIds) so booked slots can be detected
        if (getClientId != "" && getOfficeId != "" && getActiveLatestEstateIdInDB && confirmedIds.length > 0) { // replace propertyId => getActiveLatestEstateIdInDB
            getCalendarEventsFromDB();
        }
    }, [getClientId, getOfficeId, confirmedIds]);

    // get property status from estate table in local db
    const getEstateStatusInDB = async () => {
        try {       // replace propertyId => getActiveLatestEstateIdInDB
            let url = `${variables.API_URL}LocalEvents/GetEstateStatus?estateId=${getActiveLatestEstateIdInDB}&clientId=${getClientId}`;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            let response = await axios.get(url, config);
            if (response.data) {
                setCheckEstateStatusInDB(response.data);
            }
            const estateJobStatus = await getEstateJobStatus(propertyId);
            setEstateJobStatus(estateJobStatus);
        } catch (error) {
            console.log(error);
        }
    }

    // get contact from waiting list
    const getContactFromWaitingList = async () => {

        try {    // replace propertyId => getActiveLatestEstateIdInDB in url
            let url = `${variables.API_URL}Calendar/GetWaitingListData?contactId=${contactId}&estateId=${getActiveLatestEstateIdInDB}&clientID=${getClientId}`;

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            const response = await axios.get(url, {}, config)
            if (response.data.status != "Contact or WaitingList data not found in table") {
                setWaitingListContactDetail(response.data);
            }
        }
        catch (err) {
            console.log(err);
        } 
    }

    // get question and estate configuration from local db
    const getConfigurations = () => {
        addFunCallHistoryLog("get config estate before api call");
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        // replace propertyId => getActiveLatestEstateIdInDB in url
        const url = variables.API_URL + `calendar/GetEstateConfigurationsOnBookingSite?clientId=${getClientId}&estateId=${getActiveLatestEstateIdInDB}`;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                if (response.data) {
                    addFunCallHistoryLog("get config estate after response");
                    const _estateConfig = response.data;

                    if (_estateConfig != null && _estateConfig.bookableUntilType && _estateConfig.bookableUntilValue) {
                        setBookableUntilType(_estateConfig.bookableUntilType);
                        setBookableUntilValue(_estateConfig.bookableUntilValue);
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    // get office setting from local db
    const getOfficeSettings = async (errValidation) => {
        try {
            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };
            const url = variables.API_URL + `Settings/GetLocalSetting?clientId=` + getClientId;

            let response = await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers

            if (response.data) {
                let settings = response.data;

                setOfficeSetting(settings);
                let toBeConfirmed = [settings.visitToSaleBefore, settings.visitToRentBefore];
                let cofirmed = [settings.visitToSaleAfter, settings.visitToRentAfter];
                let freeslot = [settings.visitToSaleFreeSlot, settings.visitToRentFreeSlot];

                setTobeConfirmedIds(toBeConfirmed);
                setConfirmedIds(cofirmed);
                setFreeSlotIds(freeslot);
                setShowBookedSlots(settings.showBookedSlots !== false); // until backend setting exists => show booked slots

                if (settings.mappedContactTitles) {
                    setContactTitles(JSON.parse(settings.mappedContactTitles));
                }

                if (errValidation == "errorApiInEstateAndOfficeSetting") {
                    setWaitingListEnabled(settings.waitingListEnabled);
                    //setIsAutomaticSlotAccept();
                }
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        if (getActiveLatestEstateIdInDB && getClientId != "") { // replace propertyId => getActiveLatestEstateIdInDB
            getEstateStatusInDB();
            getConfigurations();
            getOfficeSettings();
            if (iframe == "waiting-list") {
                getContactFromWaitingList();
            }
        }
    }, [getActiveLatestEstateIdInDB, getClientId]) // replace propertyId => getActiveLatestEstateIdInDB

    const addFunCallHistoryLog = (funName) => {
        //const callLog = `${funName}: ${new Date().getMilliseconds()}`;
        const callLog = `${funName}: ${new Date()}`;
        setFunCallHistoryLog((prev) => [...prev, callLog]);
        //setFunCallHistoryLog([...funCallHistoryLog, callLog]);
    }

    // 2: lanugage local defualt selected
    useEffect(() => {
        if (selectedLanguage && translationsForAllLanguages) {
            const translationsForLanguage = translationsForAllLanguages[selectedLanguage];
            setSelectedLanguageTranslations(translationsForLanguage);

            const loadLocale = async () => {
                const localeKey = localeMapping[selectedLanguage];
                if (localeKey) {
                    const importedLocale = await import(`date-fns/locale/${localeKey}/index.js`);
                    setLocale(importedLocale.default);
                } else {
                    console.warn(`Locale for ${selectedLanguage} not found. Falling back to default.`);
                    setLocale(null); // Fallback to no locale
                }
            };
            loadLocale();
        }
    }, [selectedLanguage, translationsForAllLanguages])

    // time slot ui render
    useEffect(() => {
        const dateItems = document.querySelectorAll(".datepicker-item");
        //setGetDatePickterDom(dateItems);
        if (dateItems.length > 0 && whiseCalendarEvents.length > 0 && selectedLanguage && checkEstateStatusInDB == "Active") {

            let currentDate = new Date().getDate();
            let currentTime = new Date().getTime();

            dateItems.forEach((item, i) => {
                if (i === dateItems.length - 1) setShowLoader(false);

                let controlDateTime = new Date();

                // Normalize month name from DOM text
                const monthDom = normalizeForClass(item.parentElement.previousSibling.innerHTML);
                const monthIndex = monthMappingsFixed[selectedLanguage].findIndex(
                    m => normalizeForClass(m) === monthDom
                );

                const dayNumber = parseInt(item.childNodes[1].innerHTML, 10);

                // Figma: show "07 nov" and "Full" in day chip (rendered by CSS ::after)
                if (monthIndex >= 0) {
                    const shortMonth = new Intl.DateTimeFormat(selectedLanguage, { month: "short" }).format(new Date(2000, monthIndex, 1)).replace(".", "");
                    item.childNodes[1].setAttribute("data-month", shortMonth);
                }
                item.setAttribute("data-full-label", selectedLanguageTranslations?.["fullDayLabel"] ?? "Full");
                controlDateTime = setSafeDateParts(controlDateTime, controlDateTime.getFullYear(), monthIndex, dayNumber);

                if (i === 0) item.classList.add("current-day");

                whiseCalendarEvents.filter(ev => showBookedSlots || !ev.isBooked).forEach(event => {
                    const eventDateTime = new Date(event.startDateTime);
                    const eventDate = eventDateTime.getDate();
                    const eventTime = eventDateTime.getTime();

                    let distance;
                    if (bookableUntilType === "days") {
                        distance = Math.abs(currentDate - eventDate);
                    }
                    if (bookableUntilType === "hours") {
                        distance = Math.abs(currentTime - eventTime) / (1000 * 60 * 60);
                    }

                    // Create normalized class for event days
                    const monthClass = normalizeForClass(monthMappingsFixed[selectedLanguage][eventDateTime.getMonth()]);
                    item.classList.add(`${monthClass}${dayNumber}`);

                    if (
                        controlDateTime.getDate() === eventDateTime.getDate() &&
                        controlDateTime.getMonth() === eventDateTime.getMonth() &&
                        (bookableUntilValue == null || distance >= bookableUntilValue)
                    ) {
                        item.classList.add(event.isBooked ? "has-booked-event" : "has-event");
                    } else {
                        item.classList.add("no-event");
                    }

                    if (item.getAttribute("aria-disabled")) {
                        item.classList.add("d-none");
                    }
                });
            });
            // addFunCallHistoryLog("design time slots ui using dom");
        }

        // Hide empty month headers
        /*setTimeout(() => {
            document.querySelectorAll(".jb").forEach(header => {
                const visibleDays = Array.from(header.parentElement.querySelectorAll(".datepicker-item"))
                    .filter(day => !day.classList.contains("d-none"));
                header.classList.toggle("d-none", visibleDays.length === 0);
            });
        }, 100);*/
    },);

    const getWhiseToken = async () => {
        let url = "https://mink-mtsi-api.net7.be/api/User/GetWhiseTokenPerApp?appName=smartCal";
        let headers = {
            'Content-Type': 'application/json'
        };

        try {
            let resp = await axios.post(url, {},
                {
                    headers: headers
                });
            if (resp && resp.data && resp.data.token) {
                dispatch(settoken(resp.data.token))
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const getLanguageTranslations = () => {
        const jsonconfig = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetTranslationsForSiteByLang?siteName=booking`;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let translations = response.data;
                if (Object.keys(translations).length > 0) {
                    setTranslationsForAllLanguages(translations);

                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const getAllLanguage = () => {
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetAllLanguages`;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let allLanguage = response.data;
                setAllLanguageForDropwon(allLanguage);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    useEffect(() => {
        if (propertyId) {
            // setShowLoader(true);
            getWhiseToken();
            getAllLanguage();
            getLanguageTranslations();
        }
    }, [propertyId]); // date dependency remvoe

    // get office logo from local db
    const getOfficeLogo = () => {
        addFunCallHistoryLog("get office logo before api");
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetLogoByOfficeId/${getOfficeId}`;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                addFunCallHistoryLog("get office logo after response");
                let url = response.data;
                if (url && url.logoUrl) {
                    let fileName = url.logoUrl.split("UploadedFiles/")[1];
                    let imgUrl = `${variables.API_URL.split("/api")[0]}/UploadedFiles/${fileName}`;
                    setOfficeLogoUrl(imgUrl);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    useEffect(() => {
        if (getOfficeId != "") {
            getOfficeLogo();
        }
    }, [getOfficeId])

    const getClientWhiseToken = async (clientId) => {
        try {
            let url = `https://mink-mtsi-api.net7.be/api/User/GetWhiseClientTokenByAccountTypeForOtherSites?whiseToken=${whiseUserToken}&clientId=${clientId}&accountType=WebDesigner`; //&officeId=${+officeId}

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            const response = await axios.post(url, {}, config);
            if (response.data.token) {
                setClientToken(response.data.token);
                getClientWhiseEstatesList(response.data.token);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const getClientSettings = () => {
        let url = 'https://api.whise.eu/v1/admin/clients/settings';

        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${whiseUserToken}`
        };

        let body = {
            ClientId: getClientId
        };

        axios.post(url, body,
            {
                headers: headers
            })
            .then(response => {
                setClientSettings(response.data.settings);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const getWhiseOffices = () => {
        let url = "https://api.whise.eu/v1/admin/offices/list";

        const config = {
            headers: {
                'Authorization': `Bearer ${whiseUserToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, { "clientId": getClientId }, config)
            .then(response => {
                if (response.data.offices != undefined) {
                    var _filteredOffice = response.data.offices.filter((item) => { return item.id == getOfficeId });
                    setWhiseOffice(_filteredOffice[0]);
                    //console.log(_filteredOffice[0]);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    useEffect(() => {
        if (whiseUserToken != null && getClientId != "") {
            getClientWhiseToken(getClientId);
            getClientSettings();
            getWhiseOffices();
            addBookingSiteLandedLogsSaveInDB();
        }
    }, [whiseUserToken, getClientId]);

    const getClientWhiseEstatesList = async (_clientToken) => {
        try {
            let url = "https://api.whise.eu/v1/estates/list";
            const config = {
                headers: {
                    'Authorization': `Bearer ${_clientToken}`,
                    'Content-Type': 'application/json'
                },
            };

            const response = await axios.post(url, {
                "Filter": {
                    "StatusIds": [1],
                    "PurposeStatusIds": [1, 2, 5, 6, 10, 11, 12, 13, 15, 16, 20, 21, 27, 28],
                    "DisplayStatusIds": [1, 2, 3, 4, 5],
                    "EstateIds": [+getActiveLatestEstateIdInDB], // replace propertyId => getActiveLatestEstateIdInDB
                    "LanguageId": selectedLanguage
                }
            }, config);

            if (response.data) {
                setClientEstates(response.data.estates);
            }

        } catch (error) {
            console.log("error", error);
        }

    }

    useEffect(() => {
        if (clientSettings && translationsForAllLanguages) {
            if (clientSettings.defaultLanguageId) {
                //const agentDefualtLanguage = "fr-BE"; // nl-BE en-GB
                //const translationsAgentLanguage = translationsForAllLanguages[agentDefualtLanguage];
                //const translationsAgentLanguage = translationsForAllLanguages[clientSettings.defaultLanguageId];

                const clientDefaultLanguageId = clientSettings.defaultLanguageId.toLowerCase() == "nl-nl" ? "nl-BE" : clientSettings.defaultLanguageId;

                const translationsAgentLanguage = translationsForAllLanguages[clientDefaultLanguageId];
                setAgentLanguageTranslation(translationsAgentLanguage);
            }
        }
    }, [clientSettings, translationsForAllLanguages])

    useEffect(() => {
        if (slotAvailable.length > 0 && selectedLanguage != null && selectedLanguageTranslations != null) {
            setAnnouncementMessage(selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingAnnouncementSuitableDateTimeLabel"] : "Pick a slot that will suits you on");
        }
        else if (selectedLanguageTranslations != null) {
            setAnnouncementMessage(selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingQuicklyAnnouncementSuitableDateTimeLabel"] : "Quickly book the next slot");
        }
    }, [slotAvailable, selectedLanguage, selectedLanguageTranslations])

    const getCalendarActions = () => {
        let url = "https://api.whise.eu/v1/calendars/actions/list";

        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        const clientLanguageId = clientSettings ? clientSettings.defaultLanguageId.toLowerCase() == "nl-nl" ? "nl-BE" : clientSettings.defaultLanguageId : "nl-BE";

        axios.post(url, { "LanguageId": clientLanguageId }, config)
            .then(response => {
                setCalendarActions(response.data.calendarActions);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    useEffect(() => {
        if (clientEstates != undefined && clientEstates.length > 0) {
            getCalendarActions();

            let filteredEstate = clientEstates.filter(item => { // replace propertyId => getActiveLatestEstateIdInDB
                return item.id == getActiveLatestEstateIdInDB
            })

            if (filteredEstate[0].details != undefined && filteredEstate[0].details.length > 0) {
                filteredEstate[0].details.forEach(item => {
                    if (item.id == 1849) {
                        setXCoordinate(item.value);
                    }
                    if (item.id == 1850) {
                        setYCoordinate(item.value);
                    }
                })
            }
            setSelectedEstate(filteredEstate[0]);
        }
    }, [clientEstates])

    useEffect(() => {
        if (selectedEstate != null) {

            let estatePurpose = purpose.filter(item => {
                return item.id == selectedEstate.purpose.id
            })

            if (estatePurpose.length > 0) {
                setEstatePurpose(estatePurpose[0]);
            }

            // get estate sub category status from local db
            getEstateSubCategoryStatusFromLocalDB(selectedEstate.subCategory.id);
        }
    }, [selectedEstate]);

    const getAction = (actionId) => {
        let action = calendarActions.filter((d) => d.id === actionId);
        return action[0].name;
    }

    const onSelectedDay = (d) => {
        const [startValue, selectedDate] = d;
        if (!startValue && !selectedDate) return;

        /*const isBackward = date.getDate() === selectedDate.getDate();*/
        const isBackward = date === selectedDate;
        const targetDate = isBackward ? startValue : selectedDate;
        //const targetDate = selectedDate;
        const clickedDate = targetDate.getDate().toString();  // no leading zero!

        const rawMonth = monthMappingsFixed[selectedLanguage][targetDate.getMonth()];
        const monthClass = normalizeForClass(rawMonth);

        const slotsList = document.getElementsByClassName(`${monthClass}${clickedDate}`);
        /*if (!slotsList.length || !slotsList[0].classList.contains("has-event")) return;*/

        if (!slotsList.length) return;

        setDate(targetDate);
        setSelectedSlot(null);

        const dayEvents = whiseCalendarEvents.filter(ev => {
            const evDate = new Date(ev.startDateTime);
            return evDate.getDate() === targetDate.getDate() && evDate.getMonth() === targetDate.getMonth();
        });

        setSlotAvailable(dayEvents);
        selectFirstFreeSlot(dayEvents); // preselect first available slot of clicked day
    };

    const scrollLeft = () => {
        if (ref.current) {
            const container = ref.current && Array.from(ref.current.children).find(child => child.classList.contains('dr')); // Adjust the selector
            container.scrollBy({ left: -container.offsetWidth, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        if (ref.current) {
            const container = ref.current && Array.from(ref.current.children).find(child => child.classList.contains('dr')); // Adjust the selector
            container.scrollBy({ left: container.offsetWidth, behavior: 'smooth' });
        }
    };

    // same distance logic as slot rendering ("bookable until" setting)
    const isInBookableWindow = (item) => {
        if (bookableUntilValue == null) return true;
        const now = new Date();
        const itemDate = new Date(item.startDateTime);
        let distance;
        if (bookableUntilType == "days") distance = Math.abs(now.getDate() - itemDate.getDate());
        if (bookableUntilType == "hours") distance = Math.abs(now.getTime() - itemDate.getTime()) / (1000 * 60 * 60);
        return distance >= bookableUntilValue;
    }

    // select first free (not booked) slot of the day
    const selectFirstFreeSlot = (dayEvents) => {
        const item = dayEvents.find(ev => !ev.isBooked && isInBookableWindow(ev));
        if (!item) { setSelectedSlot(null); return; }

        const pad = (n) => n.toString().padStart(2, "0");
        const start = new Date(item.startDateTime);
        const end = new Date(item.endDateTime);
        const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };

        setTime(`${pad(start.getHours())}:${pad(start.getMinutes())} - ${pad(end.getHours())}:${pad(end.getMinutes())}`);
        setFormattedDate(new Intl.DateTimeFormat(selectedLanguage, options).format(start));
        setSelectedSlot(item);
    }

    const handlerSelectedSlot = async (e) => {

        let dateItem = JSON.parse(e.target.getAttribute("event"));
        //setTime(e.target.innerHTML);

        let dateObj = new Date(dateItem.startDateTime);
        let endDateObj = new Date(dateItem.endDateTime);
        let options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
        let _formattedDate = new Intl.DateTimeFormat(selectedLanguage, options).format(dateObj);

        // Extract hours and minutes for the start and end times
        let startHours = dateObj.getHours() < 10 ? "0" + dateObj.getHours() : dateObj.getHours();
        let startMinutes = dateObj.getMinutes() < 10 ? "0" + dateObj.getMinutes() : dateObj.getMinutes();
        let endHours = endDateObj.getHours() < 10 ? "0" + endDateObj.getHours() : endDateObj.getHours();
        let endMinutes = endDateObj.getMinutes() < 10 ? "0" + endDateObj.getMinutes() : endDateObj.getMinutes();
        setTime(`${startHours}:${startMinutes} - ${endHours}:${endMinutes}`);
        setFormattedDate(_formattedDate);

        let dataItem = JSON.parse(e.target.getAttribute("event"));
        setSelectedSlot(dataItem);

        //let body = {}
        //body.CalendarIds = [+dateItem.id];
        //body.IncludeRecurrences = true;
        //if (dateItem.isLocalDbEvent) {
        //    await getLocalCalenderEventById(dateItem.id);
        //}
        //else {
        //    await getWhiseCalenderEventById(body);
        //}
        //if (eventExist) {
        //    let dateItem = JSON.parse(e.target.getAttribute("event"));
        //    setSelectedSlot(dateItem);
        //} else {
        //    alert(selectedLanguageTranslations != null ? selectedLanguageTranslations["alertSlotAlreadyBooked"] : "This Slot is already booked and not available please try an Other slot");
        //}
    }

    const getLocalCalenderEventById = async (id) => {

        let url = variables.API_URL + `LocalEvents/GetLocalEventById?clientId=${getClientId}&officeId=${getOfficeId}&eventId=${id}`;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, {}, config);

        if (response.data && response.data.calendars) {
            eventExist = true;
        }
        else {
            eventExist = false;
        }
    }

    const getToBeConfirmedIds = (purposeId, calenderActionId) => {
        if (tobeConfirmedIds != undefined && calenderActionId == "tobeconfirm") {
            if (purposeId == 1) {
                return tobeConfirmedIds[0];
            }
            else if (purposeId == 2) {
                return tobeConfirmedIds[1];
            }
        } else if (confirmedIds != undefined && calenderActionId == "confirm") {
            if (purposeId == 1) {
                return confirmedIds[0];
            }
            else if (purposeId == 2) {
                return confirmedIds[1];
            }
        }
    }

    const handlerResetSelectedSlot = () => {
        setSelectedSlot(null);
        getCalendarEventsFromDB();
    }

    function setSafeDateParts(baseDate, year, monthIndex, day) {
        // Clamp the day to the maximum valid day in the target month
        const lastValidDay = new Date(year, monthIndex + 1, 0).getDate();
        const safeDay = Math.min(day, lastValidDay);

        return new Date(year, monthIndex, safeDay);
    }

    useEffect(() => {
        if (yCoordinate != "" && xCoordinate != "") {
            let url = "https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/pin-s-l+ff0000(" + yCoordinate + "," + xCoordinate + ")/" + yCoordinate + "," + xCoordinate + ",14/675x420?access_token=pk.eyJ1IjoibWluZGZyZWUiLCJhIjoiY2xkbzlvOXJjMDd2ZTNucXZ5cmJ2aW9weSJ9.-Qp-drHs8IPsY7Oo5WZXRA";
            setMapUrl(url);
        }
    }, [yCoordinate, xCoordinate])

    const formatPrice = (price, symbol) => {
        let formattedPrice = new Intl.NumberFormat('fr-BE', { style: 'currency', currency: 'EUR' }).format(price,);
        //let index = formattedPrice.indexOf(symbol);

        //let finalPrice = formattedPrice.substr(index+1)

        //return finalPrice + " " + symbol;
        return formattedPrice;
    }

    const clickHandleOpenBookSlotWindow = (e) => {
        if (e.target.nodeName == "p" || e.target.nodeName == "path" || e.target.nodeName == "svg") {
            document.getElementById("btnShowBookSlotWindow").classList.remove("d-block");
            document.getElementById("btnShowBookSlotWindow").classList.add("d-none");
        }
        else {
            e.target.classList.remove('d-block');
            e.target.classList.add('d-none');
        }
        document.getElementById("overlayDiv").classList.remove("d-none");
        document.getElementById("bookSlotForm").classList.remove("d-none", "d-md-none");
    }

    const handleCloseBookSlotWindow = () => {
        if (document.getElementById("btnShowBookSlotWindow") != null) {
            document.getElementById("bookSlotForm").classList.add("d-none", "d-md-none");
        }
        if (document.getElementById("btnShowBookSlotWindow") != null) {
            document.getElementById("btnShowBookSlotWindow").classList.remove("d-none");
            document.getElementById("btnShowBookSlotWindow").classList.add("d-block");
        }
        if (document.getElementById("overlayDiv") != null) {
            document.getElementById("overlayDiv").classList.add("d-none");
        }
    }

    const handleAddContactInWaitingList = () => {
        setShowModal(true);
    }

    useEffect(() => {
        if (isMobile == false) {
            handleCloseBookSlotWindow();
        }
    }, [isMobile])

    // check selected event exist on whise or not
    const getWhiseCalenderEventById = async (filters) => {
        let url = "https://api.whise.eu/v1/calendars/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };
        let body = {
            "Filter": { //filters
                CalendarIds: [+filters.whiseEventId]
            }
        };
        await axios.post(url, body, config)
            .then(response => {
                if (response.data !== undefined && response.data.calendars !== undefined) {
                    eventExist = true;
                } else {
                    eventExist = false;
                }
            })
            .catch(error => {
                console.log("error", error);
            });
    }

    // delete event from lcoal db when event remove from whise
    const deleteFreeSlotFromLocalDB = (selectedSlot) => {
        setTimeSlotUpdateLoader(true);
        let url = variables.API_URL + `LocalEvents/DeleteEventsByIdFromBookingSite?eventId=${+selectedSlot.id}`;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, {}, config)
            .then(response => {
                if (response.data && freeSlotIds.length > 0) {
                    updateEstateStatusInDB();
                    setSelectedSlot(null);
                    getCalendarEventsFromDB();
                    setTimeSlotUpdateLoader(false);
                }
            })
            .catch(error => {
                console.log("error", error);
                setTimeSlotUpdateLoader(false);
            });
    }

    // update estate status 
    const updateEstateStatusInDB = async () => {
        try {
            let url = `${variables.API_URL}LocalEvents/UpdateEstateStatus`;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            const body = {
                estateId: selectedEstate.id,
                clientId: +getClientId
            }

            const response = await axios.post(url, body, config);
            console.log(response);

        } catch (error) {
            console.log("event update in db:", error);
        }
    }

    const onChangeSelectLanguage = (e) => {
        const selectedIndex = e.target.selectedIndex;
        const selectedText = e.target.options[selectedIndex].text;
        setSelectedLanguage(selectedText);
        if (selectedSlot) {
            let dateObj = new Date(selectedSlot.startDateTime);
            let endDateObj = new Date(selectedSlot.endDateTime);
            let options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
            let _formattedDate = new Intl.DateTimeFormat(selectedText, options).format(dateObj);
            setFormattedDate(_formattedDate);
        }
    }

    const handleClose = () => {
        setPrevSelectedEventSlot(selectedSlot);
        setShowModal(false);
        let _formStep = formStep;
        setFormStep(1);
        if (_formStep > 2) {
            window.location.reload(false);
        }
    };

    const handlerBookSlot = async () => {
        setShowButtonLoader(true);
        let body = {}
        if (selectedSlot != null) {
            //setFormStep(1);
            //setShowModal(true);
            dispatch(clearMailVerificationDetail());
            body.CalendarIds = [+selectedSlot.id];
            //body.IncludeRecurrences = true;

            if (selectedSlot.isLocalDbEvent) {
                await getLocalCalenderEventById(selectedSlot.id);
                if (selectedSlot.whiseEventId != null) {
                    await getWhiseCalenderEventById(selectedSlot);
                }
            }
            else {
                await getWhiseCalenderEventById(selectedSlot);
                /*await getWhiseCalenderEventById(body);*/
            }

            if (eventExist) {
                setShowModal(true);
            } else {
                //alert("This Slot is already booked and not available please try an Other slot")
                alert(selectedLanguageTranslations != null ? selectedLanguageTranslations["alertSlotAlreadyBooked"] : "This Slot is already booked and not available please try an Other slot");
                deleteFreeSlotFromLocalDB(selectedSlot);
            }
            setShowButtonLoader(false);
        }
        else {
            setShowButtonLoader(false);
            alert(selectedLanguageTranslations != null ? selectedLanguageTranslations["alertFreeSlotChoose"] : "please choose a slot");
        }
    }

    const addBookingSiteLandedLogsSaveInDB = async () => {

        try {
            const ipAddress = await getIpAddress();

            let queryParamUrl = queryParamObj(queryParams);

            const url = `${variables.API_URL}Calendar/AddBookingSiteAcessLogs`;

            const body = {
                estateId: getActiveLatestEstateIdInDB, // replace propertyId => getActiveLatestEstateIdInDB
                clientId: getClientId != "" ? getClientId : null,
                contactId: contactId != "32065699" ? +contactId : null,
                ipAddress: ipAddress,
                contactFirstName: queryParamUrl.firstName,
                contactName: queryParamUrl.name,
                contactEmail: queryParamUrl.email,
                contactMobile: queryParamUrl.mobile,
            }

            const response = await axios.post(url, body);
            if (response.data) {
                console.log(response.data);
            }


        } catch (error) {
            console.log(error);
        }
    }

    const getEstateSubCategoryStatusFromLocalDB = async (subCategoryId) => {

        try {
            let url = `${variables.API_URL}LocalEvents/GetEstateSubCategoryStatus?Id=${subCategoryId}`;

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, config);

            if (response.data) {
                setEstateSubCategory(response.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    // Active estate, but no free slot can be booked (no free slots, or all free slots blocked by "bookable until")
    // => show the waiting list UI instead of "No free slot available"
    const showWaitingListForNoSlots = checkEstateStatusInDB == "Active" && waitingListEnabled && eventsLoaded &&
        !whiseCalendarEvents.some(ev => !ev.isBooked && isInBookableWindow(ev));

    // EventModal opens in waiting-list mode for "Pending"
    const bookingStatusForModal = showWaitingListForNoSlots ? "Pending" : checkEstateStatusInDB;

    return (
        <>
            <div className={`overlay-div d-none`} id="overlayDiv"></div>
            {
                estateInActiveInLocalDb == true && getClientId == "" && getOfficeId == "" ?
                    <div className="estateInactive-container d-flex justify-content-center align-items-center">
                        <div className="text-center">
                            <img src={mindFreeLogo} alt="mind free logo" className="mb-4" />
                            <p>{selectedLanguageTranslations != null ? selectedLanguageTranslations["propertyNotActivated"] : "This property has not been activated for online booking visit."}</p>
                        </div>
                    </div>
                    :
                    <>
                        { // replace propertyId => getActiveLatestEstateIdInDB
                            getActiveLatestEstateIdInDB != undefined ?
                                <div className={`${isMobile == true ? "container-fluid" : "container"} p-3`}>
                                    <div className={`row align-items-center mb-4 ${iframe == "iframe" ? "d-none" : ""}`}>
                                        <div className="col-12">
                                            <div className="d-flex justify-content-end">
                                                <div className="d-flex align-items-center ms-5 position-relative language-dropdown-container bg-white">
                                                    <img src={languageDropdownIcon} className="position-absolute ps-2 start-0 language-dropdown-icon" />
                                                    <select className="form-select fs-1-1 bg-transparent" aria-label="Default select example" value={selectedLanguage ? selectedLanguage : defaultLanguage} onChange={onChangeSelectLanguage}>
                                                        {
                                                            allLanguageForDropwon.length > 0 ?
                                                                allLanguageForDropwon.map((item) => {
                                                                    return (
                                                                        <option key={item.id} value={item.languageCode}> {item.languageCode}</option>
                                                                    )
                                                                })
                                                                :
                                                                <></>
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row-reverse">

                                        {
                                            (checkEstateStatusInDB == "Pending" || showWaitingListForNoSlots) && waitingListEnabled ?
                                                <div className={`col-lg-4 mb-3 ${iframe == "iframe" ? "" : "booking-section"} container-sm`}>
                                                    <div className={`form-container`} id="bookSlotForm">
                                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                                            <h6 className="m-0">{selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingWindowTitle"] : "Book a visit"}</h6>
                                                            {
                                                                officeLogoUrl ?
                                                                    <img src={officeLogoUrl} alt="logo" width="70px" />
                                                                    :
                                                                    clientSettings && clientSettings.logoUrl ?
                                                                        <img src={clientSettings.logoUrl} alt="logo" width="70px" />
                                                                        :
                                                                        <></>
                                                            }
                                                        </div>
                                                        <div className="waiting-list-alert-container p-4 mb-3">
                                                            <img src={alertSpeaker} className="mb-3" alt="alert speaker" />
                                                            <h4 className="sub-heading mb-2">{selectedLanguageTranslations != null ? selectedLanguageTranslations["waitingAlertHeading"] : "Sorry, no visit slots are currently available."}</h4>
                                                            <p className="content-text mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["registerWaitingListNotification"] : "Register for the waiting list to receive a notification when this property becomes available for visits."}</p>
                                                            <button type="button" className="waiting-btn w-100 site-btn-padd" onClick={handleAddContactInWaitingList}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["waitingListBtnTxt"] : "Sign up on the waiting list"}</button>
                                                        </div>
                                                        <div className="waiting-list-alert-container p-3 d-flex">
                                                            <img src={errorMessage} className="me-3" alt="alert speaker" />
                                                            <p className="content-text text-red mb-0">{selectedLanguageTranslations != null ? selectedLanguageTranslations["noPhoneContact"] : "There is no need to contact us by phone: all visit options are systematically added and managed exclusively through this platform."}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                (checkEstateStatusInDB.toLowerCase() == "onhold" || checkEstateStatusInDB.toLowerCase() == "start") && waitingListEnabled ?
                                                    <div className={`col-lg-4 mb-3 ${iframe == "iframe" ? "" : "booking-section"} container-sm`}>
                                                        <div className={`form-container`} id="bookSlotForm">
                                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                                <h6 className="m-0">{selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingWindowTitle"] : "Book a visit"}</h6>
                                                                {
                                                                    officeLogoUrl ?
                                                                        <img src={officeLogoUrl} alt="logo" width="70px" />
                                                                        :
                                                                        clientSettings && clientSettings.logoUrl ?
                                                                            <img src={clientSettings.logoUrl} alt="logo" width="70px" />
                                                                            :
                                                                            <></>
                                                                }
                                                            </div>
                                                            <div className="waiting-list-alert-container p-4 mb-3">
                                                                <img src={alertSpeaker} className="mb-3" alt="alert speaker" />
                                                                {
                                                                    checkEstateStatusInDB.toLowerCase() == "start" ?
                                                                        <>
                                                                            <h4 className="sub-heading mb-2">{selectedLanguageTranslations != null ? selectedLanguageTranslations["viewingsNotYetOpen"] : "Viewings for this property are not yet open."}</h4>
                                                                            <p className="content-text mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["joinWaitingListNotifySlots"] : "Join the waiting list to be notified as soon as time slots become available."}</p>
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <h4 className="sub-heading mb-2">{selectedLanguageTranslations != null ? selectedLanguageTranslations["propertyVisitsSuspendedUnderOffer"] : "Viewings for this property are temporarily suspended."}</h4>
                                                                            <p className="content-text mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["propertyAvailableNotifyWaitingList"] : "Join the waiting list to be notified as soon as they resume."}</p>
                                                                        </>
                                                                }
                                                                <button type="button" className="waiting-btn w-100 site-btn-padd" onClick={handleAddContactInWaitingList}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["waitingListBtnTxt"] : "Sign up on the waiting list"}</button>
                                                            </div>
                                                            <div className="waiting-list-alert-container p-3 d-flex">
                                                                <img src={errorMessage} className="me-3" alt="alert speaker" />
                                                                <p className="content-text text-red mb-0">{selectedLanguageTranslations != null ? selectedLanguageTranslations["noPhoneContact"] : "There is no need to contact us by phone: all visit options are systematically added and managed exclusively through this platform."}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    checkEstateStatusInDB == "Deactivate" && clientSettings != null ?
                                                        <div className={`col-lg-4 mb-3 ${iframe == "iframe" ? "" : "booking-section"} container-sm`}>
                                                            <div className={`form-container`} id="bookSlotForm">
                                                                <div className="d-flex justify-content-between align-items-center mb-4">
                                                                    <h6 className="m-0">{selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingWindowTitle"] : "Book a visit"}</h6>
                                                                    {
                                                                        officeLogoUrl ?
                                                                            <img src={officeLogoUrl} alt="logo" width="70px" />
                                                                            :
                                                                            clientSettings && clientSettings.logoUrl ?
                                                                                <img src={clientSettings.logoUrl} alt="logo" width="70px" />
                                                                                :
                                                                                <></>
                                                                    }
                                                                </div>
                                                                <div className="deactive-estate-alert-container p-4 mb-3">
                                                                    <img src={deactiveAlert} className="mb-3" alt="deactive alert" />
                                                                    <h4 className="sub-heading mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["propertyUnavailable"] : "This property is no longer available for viewing as it has already been rented/sold."}</h4>
                                                                    <button type="button" className="red-bg-btn w-100 site-btn-padd">{selectedLanguageTranslations != null ? selectedLanguageTranslations["seeOtherProperties"] : "See other available properties"}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className={`col-lg-4 mb-3 ${iframe == "iframe" ? "" : "booking-section"} container-sm`}>
                                                            <div className={`form-container d-lg-block d-xl-block d-xxl-block ${iframe == "iframe" ? "d-block" : "d-none d-md-none form-container-sm"}`} id="bookSlotForm" style={{ position: "relative" }}>

                                                                {/* BLOCKING OVERLAY show when Estate Job Status !== "completed" */}

                                                                <div className={`${checkEstateStatusInDB.toLowerCase() == "active" && estateJobStatus.toLowerCase() != "completed" && estateJobStatus.toLowerCase() != "abort" && estateJobStatus.toLowerCase() != "estate is not available in db" && estateJobStatus.toLowerCase() != "job status is null in db" && whiseCalendarEvents.length > 0 ? "" : "d-none"}`}>
                                                                    <LockOverlayUI selectedLanguage={selectedLanguage} />
                                                                </div>

                                                                <p className={`mb-lg-0 d-flex justify-content-end ${iframe == "iframe" ? "d-none" : "d-block"}`}><img src={closeIcon} onClick={handleCloseBookSlotWindow} className="cursor-pointer d-lg-none d-xl-none d-xxl-none d-md-block d-sm-block" /></p>
                                                                <div className="d-flex justify-content-between align-items-center mb-4">
                                                                    <h6 className="m-0">{selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingWindowTitle"] : "Book a visit"}</h6>
                                                                    {
                                                                        officeLogoUrl ?
                                                                            <img src={officeLogoUrl} alt="logo" width="70px" />
                                                                            :
                                                                            clientSettings && clientSettings.logoUrl ?
                                                                                <img src={clientSettings.logoUrl} alt="logo" width="70px" />
                                                                                :
                                                                                <></>
                                                                    }
                                                                </div>
                                                                <div className="slot-announcement mb-4">
                                                                    <img src={megaphone} alt="megaphone" />
                                                                    <span className="announcement">{announcementMessage},
                                                                        <span className="today-time">
                                                                            {
                                                                                whiseCalendarEvents.length > 0 && date ? whiseCalendarEvents.filter(ev => !ev.isBooked).map((item, i) => {
                                                                                    let selectedDate = date;
                                                                                    const daysNamesForTranslationKeys = days;
                                                                                    const monthNamesForTranslationKeys = ["january", "february", "march", "april", "may", "june",
                                                                                        "july", "august", "september", "october", "november", "december"
                                                                                    ];
                                                                                    let itemDate = new Date(item.startDateTime);

                                                                                    let currentDateTime = new Date();
                                                                                    let currentDate = currentDateTime.getDate();
                                                                                    let currentTime = currentDateTime.getTime();
                                                                                    let eventDate = itemDate.getDate();
                                                                                    let eventTime = itemDate.getTime();

                                                                                    let distance;
                                                                                    if (bookableUntilType && bookableUntilType == "days") {
                                                                                        distance = currentDate > eventDate ? currentDate - eventDate : eventDate - currentDate;
                                                                                    }
                                                                                    if (bookableUntilType && bookableUntilType == "hours") {
                                                                                        let differenceInMilliseconds = currentTime > eventTime ? currentTime - eventTime : eventTime - currentTime;
                                                                                        distance = differenceInMilliseconds / (1000 * 60 * 60);
                                                                                    }

                                                                                    //bypass past events 
                                                                                    if (itemDate >= selectedDate && (bookableUntilValue == null || distance >= bookableUntilValue)) {

                                                                                        if (firstMatchFound == false && itemDate.getDate() == selectedDate.getDate()) {
                                                                                            let dayIndex = itemDate.getDay();
                                                                                            let monthDate = selectedDate.getDate();
                                                                                            let monthIndex = selectedDate.getMonth();
                                                                                            firstMatchFound = true;

                                                                                            return (
                                                                                                <span className="ms-1" key={i}>
                                                                                                    {selectedLanguageTranslations[daysNamesForTranslationKeys[dayIndex] + "FullDayName"] + " " + monthDate + " " + selectedLanguageTranslations[monthNamesForTranslationKeys[monthIndex]] + " !"}
                                                                                                </span>
                                                                                            )
                                                                                        }
                                                                                        else if (firstMatchFound == false) {
                                                                                            let dayIndex = itemDate.getDay();
                                                                                            let monthDate = itemDate.getDate();
                                                                                            let monthIndex = itemDate.getMonth();
                                                                                            let hours = itemDate.getHours() < 10 ? "0" + itemDate.getHours() : itemDate.getHours();
                                                                                            let minutes = itemDate.getMinutes() < 10 ? "0" + itemDate.getMinutes() : itemDate.getMinutes();
                                                                                            var time = hours + ":" + minutes;
                                                                                            firstMatchFound = true;
                                                                                            let atText = selectedLanguageTranslations != null ? ` ${selectedLanguageTranslations["atTextForDateTime"]} ` : " at ";

                                                                                            return (
                                                                                                <span className="ms-1" key={i}>
                                                                                                    {selectedLanguageTranslations[daysNamesForTranslationKeys[dayIndex] + "FullDayName"] + " " + monthDate + " " + selectedLanguageTranslations[monthNamesForTranslationKeys[monthIndex]] + atText + time + " !"}
                                                                                                </span>
                                                                                            )
                                                                                        }
                                                                                    }
                                                                                })
                                                                                    :
                                                                                    <></>
                                                                            }
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                                <div className={`mb-3 ${showLoader ? "" : "d-none"}`}>
                                                                    <span className="spinner-border text-primary spinner-border-sm me-1" aria-hidden="true"></span>
                                                                    <span role="status">
                                                                        {
                                                                            selectedLanguageTranslations ? selectedLanguageTranslations["loadingText"] : "Loading..."
                                                                        }
                                                                    </span>
                                                                </div>
                                                                <p className={`mb-0 today-time d-none`}>{selectedLanguageTranslations ? selectedLanguageTranslations[monthNamesForTranslationKeys[date.getMonth()]] : "months"}</p>
                                                                <div className={`d-flex align-items-center mb-2 position-relative${showLoader || whiseCalendarEvents.length == 0 ? " d-none" : ""}`}>
                                                                    <button className="btn-datepicker-nav-left" onClick={scrollLeft}><img src={angleLeft} width="45" /></button>
                                                                    <Datepicker
                                                                        locale={locale}
                                                                        onChange={onSelectedDay}
                                                                        startValue={date}
                                                                        disabledDates={disableDates}
                                                                        ref={ref}
                                                                        classNames={{ dayLabel: "week-days", dayItem: "datepicker-item", monthLabel: "months" }}
                                                                    />
                                                                    <button className="btn-datepicker-nav-right" onClick={scrollRight}><img src={angleRight} width="45" /></button>
                                                                </div>
                                                                <div className={`mb-3 ${showLoader == false && whiseCalendarEvents.length == 0 ? "" : "d-none"}`}>
                                                                    {
                                                                        selectedLanguageTranslations ? selectedLanguageTranslations["noFreeSlotAvailableMessage"] : "No free slot available"
                                                                    }
                                                                </div>
                                                                <p className={`hour-heading mb-2 ${whiseCalendarEvents.length == 0 ? "d-none" : ""}`}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingAvailableSlotsTitle"] : "Available slots"}</p>
                                                                {
                                                                    timeSlotUpdateLoader ?
                                                                        <div className={`mb-3`}>
                                                                            <span className="spinner-border text-primary spinner-border-sm me-1" aria-hidden="true"></span>
                                                                        </div>
                                                                        :
                                                                        /*<div className="align-items-center mb-4">
                                                                            {
                                                                                whiseCalendarEvents.length > 0 && date ?
                                                                                    whiseCalendarEvents.map((item, i) => {
                                                                                        let selectedDate = date;
                                                                                        let itemDateTime = new Date(item.startDateTime);
                                                                                        let currentDateTime = new Date();
                                                                                        let currentDate = currentDateTime.getDate();
                                                                                        let currentTime = currentDateTime.getTime();
                                                                                        let eventDate = itemDateTime.getDate();
                                                                                        let eventTime = itemDateTime.getTime();
                
                                                                                        let distance;
                                                                                        if (bookableUntilType == "days") {
                                                                                            distance = currentDate > eventDate ? currentDate - eventDate : eventDate - currentDate;
                                                                                        }
                                                                                        if (bookableUntilType == "hours") {
                                                                                            let differenceInMilliseconds = currentTime > eventTime ? currentTime - eventTime : eventTime - currentTime;
                                                                                            distance = differenceInMilliseconds / (1000 * 60 * 60);
                                                                                        }
                
                
                                                                                        if (selectedDate.getDate() == itemDateTime.getDate() && selectedDate.getMonth() == itemDateTime.getMonth() && (bookableUntilValue == null || distance >= bookableUntilValue)) {
                                                                                            let hours = itemDateTime.getHours() < 10 ? "0" + itemDateTime.getHours() : itemDateTime.getHours();
                                                                                            let minutes = itemDateTime.getMinutes() < 10 ? "0" + itemDateTime.getMinutes() : itemDateTime.getMinutes();
                                                                                            let time = hours + ":" + minutes;
                
                                                                                            return (
                                                                                                <button className={`available-hour mb-0 me-1 ${selectedSlot != null && selectedSlot.id == item.id ? "active" : ""}`}
                                                                                                    key={i} onClick={handlerSelectedSlot}
                                                                                                    event={JSON.stringify(item)}>
                                                                                                    {time}
                                                                                                </button>
                                                                                            )
                                                                                        }
                                                                                    })
                                                                                    :
                                                                                    <></>
                                                                            }
                                                                        </div>*/
                                                                        <div className="time-slot-grid mb-3">
                                                                            {
                                                                                whiseCalendarEvents.length > 0 && date ? (() => {
                                                                                    const uniqueTimes = new Set(); // move outside map

                                                                                    return whiseCalendarEvents.map((item, i) => {
                                                                                        let selectedDate = date;
                                                                                        let itemDateTime = new Date(item.startDateTime);
                                                                                        let currentDateTime = new Date();
                                                                                        let currentDate = currentDateTime.getDate();
                                                                                        let currentTime = currentDateTime.getTime();
                                                                                        let eventDate = itemDateTime.getDate();
                                                                                        let eventTime = itemDateTime.getTime();

                                                                                        let distance;
                                                                                        if (bookableUntilType == "days") {
                                                                                            distance = currentDate > eventDate ? currentDate - eventDate : eventDate - currentDate;
                                                                                        }
                                                                                        if (bookableUntilType == "hours") {
                                                                                            let differenceInMilliseconds = currentTime > eventTime ? currentTime - eventTime : eventTime - currentTime;
                                                                                            distance = differenceInMilliseconds / (1000 * 60 * 60);
                                                                                        }

                                                                                        if (
                                                                                            selectedDate.getDate() == itemDateTime.getDate() &&
                                                                                            selectedDate.getMonth() == itemDateTime.getMonth() &&
                                                                                            (bookableUntilValue == null || distance >= bookableUntilValue)
                                                                                        ) {
                                                                                            let hours = itemDateTime.getHours().toString().padStart(2, "0");
                                                                                            let minutes = itemDateTime.getMinutes().toString().padStart(2, "0");
                                                                                            let time = `${hours}:${minutes}`;

                                                                                            // hide booked slots when client setting is off
                                                                                            if (item.isBooked && !showBookedSlots) return null;

                                                                                            // only show once
                                                                                            if (item.isBooked || !uniqueTimes.has(time)) {
                                                                                                if (!item.isBooked) uniqueTimes.add(time);
                                                                                                return (
                                                                                                    <button
                                                                                                        key={i}
                                                                                                        className={`available-hour ${item.isBooked ? "booked" : ""} ${selectedSlot?.id == item.id ? "active" : ""}`}
                                                                                                        aria-pressed={selectedSlot?.id == item.id}
                                                                                                        onClick={handlerSelectedSlot}
                                                                                                        disabled={item.isBooked}
                                                                                                        event={JSON.stringify(item)}
                                                                                                    >
                                                                                                        {time}
                                                                                                    </button>
                                                                                                );
                                                                                            }
                                                                                        }
                                                                                        return null;
                                                                                    });
                                                                                })()
                                                                                    : null
                                                                            }
                                                                        </div>

                                                                }
                                                                {/* <div className={`slot-legend mb-4 ${whiseCalendarEvents.length == 0 ? "d-none" : ""}`}>
                                                                    <div>{selectedLanguageTranslations?.["slotLegendAvailable"] ?? "Light green: available \u00b7 \u2713 Dark green: selected"}</div>
                                                                    {
                                                                        showBookedSlots ?
                                                                            <>
                                                                                <div>{selectedLanguageTranslations?.["slotLegendBooked"] ?? "Crossed-out times: already booked"}</div>
                                                                                <div>{selectedLanguageTranslations?.["slotLegendFull"] ?? "Full: all time slots reserved for this day"}</div>
                                                                            </>
                                                                            : null
                                                                    }
                                                                </div> */}
                                                                {
                                                                    selectedSlot == null ?
                                                                        <button type="button" className="site-btn w-100 site-btn-padd disabled" disabled>{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingBtn"] : "Book a Slot"}</button>
                                                                        :
                                                                        <button type="button" className="site-btn w-100 site-btn-padd" onClick={handlerBookSlot}>
                                                                            {
                                                                                showButtonLoader ?
                                                                                    <>
                                                                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                                        <span class="visually-hidden">Loading...</span>
                                                                                    </>
                                                                                    :
                                                                                    selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingBtn"] : "Book a Slot"
                                                                            }
                                                                        </button>
                                                                }
                                                            </div>
                                                            <button className={`site-btn w-100 site-btn-padd booking-float-btn d-lg-none d-xl-none d-xxl-none ${iframe == "iframe" ? "d-none" : "d-block booking-btn-sm"}`} id="btnShowBookSlotWindow" onClick={clickHandleOpenBookSlotWindow}>
                                                                <FontAwesomeIcon icon={faChevronUp} /><br></br>
                                                                {selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingBtn"] : "Book a Slot"}
                                                            </button>
                                                        </div>
                                        }
                                        <div className={`col-lg-8 ${iframe == "iframe" ? "d-none" : ""}`}>
                                            <div className="property-page-container bg-white mb-5">
                                                <div className="property-detail-container">
                                                    <p className='property-detail-label d-inline-block fs-1-1 text-center mb-3'>{selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingSiteAgencyLabel"] : "Agency"}</p>
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-12 col-md-4 col-lg-4">
                                                            {
                                                                officeLogoUrl ?
                                                                    <img src={officeLogoUrl} className="main-logo mb-sm-3 mb-md-0 mb-lg-0 mb-xl-0 mb-xxl-0 mb-3" alt="Logo" />
                                                                    :
                                                                    clientSettings && clientSettings.logoUrl ?
                                                                        <img src={clientSettings.logoUrl} className="main-logo mb-sm-3 mb-md-0 mb-lg-0 mb-xl-0 mb-xxl-0 mb-3" alt="Logo" />
                                                                        :
                                                                        <></>
                                                            }
                                                        </div>
                                                        <div className="col-sm-12 col-md-8 col-lg-8">
                                                            <h4 className="heading mb-3">{whiseOffice != null && whiseOffice.name !== undefined ? whiseOffice.name : ""}</h4>
                                                            <div className="d-flex align-items-center mb-3">
                                                                <img src={locationPin} alt="Location" />
                                                                {
                                                                    whiseOffice != null ? <h5 className="fs-1-1 ms-2 mb-0">{(whiseOffice.address1 !== undefined ? whiseOffice.address1 + " " : "") + (whiseOffice.number !== undefined ? whiseOffice.number + ", " : "") + (whiseOffice.zip != undefined ? whiseOffice.zip + " " : "") + (whiseOffice.city != undefined ? whiseOffice.city : "")}</h5> : <h5 className="ms-2"></h5>
                                                                }
                                                            </div>
                                                            <div className="d-flex align-items-center mb-3">
                                                                <img src={phone} alt="phone icon" />
                                                                <h5 className="fs-1-1 ms-2 mb-0">{whiseOffice != null && whiseOffice.telephone != undefined ? whiseOffice.telephone : ""}</h5>
                                                            </div>
                                                            <div className="d-flex align-items-center mb-3">
                                                                <img src={websiteIcon} alt="phone icon" />
                                                                <h5 className="fs-1-1 ms-2 mb-0">{whiseOffice != null && whiseOffice.website != undefined ? whiseOffice.website : ""}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p className="property-page-label fs-1-1 text-center mt-3">{selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingSiteVisitRequestPropertyLabel"] : "Visit request page for property"}</p>
                                            </div>
                                            <div className="main-img mb-5">
                                                <img src={selectedEstate != null && selectedEstate.pictures != undefined && selectedEstate.pictures.length > 0 ? selectedEstate.pictures[0].urlLarge : propMainImg}
                                                    className="rounded-4" width="100%" alt="house image" />
                                            </div>
                                            <div className="form-container d-flex justify-content-between align-items-center position-relative mb-4">
                                                <div>
                                                    <h4 className="capitalize-first heading mb-0 mt-2">
                                                        {/*<span>{selectedEstate != null ? selectedEstate.subCategory.id : ""} </span>*/}
                                                        <span>{selectedEstate != null ? selectedLanguage == "en-GB" ? estateSubCategory != "" ? estateSubCategory.nameEn : "" : selectedLanguage == "fr-BE" ? estateSubCategory != "" ? estateSubCategory.nameFr : "" : estateSubCategory != "" ? estateSubCategory.nameNl : "" : ""} </span>
                                                        <span className={`${selectedEstate != null && selectedEstate.rooms && selectedEstate.rooms != 0 ? "" : "d-none"}`}> - {selectedEstate != null ? selectedEstate.rooms : ""} {selectedLanguageTranslations != null ? selectedLanguageTranslations["rooms"] : "Rooms"}</span>
                                                        <span className={`${selectedEstate != null && selectedEstate.terrace ? "" : "d-none"}`}> - {selectedLanguageTranslations != null ? selectedLanguageTranslations["terrace"] : "Terrace"}</span>
                                                        <span className={`${selectedEstate != null && selectedEstate.garage ? "" : "d-none"}`}> - {selectedLanguageTranslations != null ? selectedLanguageTranslations["garage"] : "Garage"}</span>
                                                        <span className={`${selectedEstate != null && selectedEstate.parking ? "" : "d-none"}`}> - {selectedLanguageTranslations != null ? selectedLanguageTranslations["parking"] : "Parking"}</span>
                                                        <span className={`${selectedEstate != null && selectedEstate.garden ? "" : "d-none"}`}> - {selectedLanguageTranslations != null ? selectedLanguageTranslations["garden"] : "Garden"}</span>
                                                    </h4>

                                                    {/*<h4 className="heading mb-0 mt-2">{selectedEstate != null ? selectedEstate.name : ""}</h4>*/}
                                                    <p className="sab-heading mb-2">{selectedEstate != null ? formatPrice(selectedEstate.price, selectedEstate.currency) : 0}</p>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <div className="border-end pe-4 room-products">
                                                        <img src={bed} alt="bed" className={`${selectedEstate != null && selectedEstate.bedRooms != undefined ? "me-1" : ""}`} />  {selectedEstate != null && selectedEstate.bedRooms != undefined ? selectedEstate.bedRooms : ""}
                                                    </div>
                                                    <div className="border-end px-4 room-products">
                                                        <img src={p_shower} alt="shower" className={`${selectedEstate != null && selectedEstate.bathRooms != undefined ? "me-1" : ""}`} /> {selectedEstate != null && selectedEstate.bathRooms != undefined ? selectedEstate.bathRooms : ""}
                                                    </div>
                                                    <div className="ps-4 room-products">
                                                        <img src={lift} alt="lift" className={`${selectedEstate != null && selectedEstate.area != undefined ? "me-1" : ""}`} /> {selectedEstate != null && selectedEstate.area != undefined ? <>{selectedEstate.area}<span className="ms-05">m</span><sup>2</sup></> : ""}
                                                    </div>
                                                </div>
                                                {
                                                    estatePurpose != null ?
                                                        <div className="position-absolute text-center sale-tag">
                                                            {
                                                                estatePurpose.name
                                                            }
                                                        </div>
                                                        :
                                                        <></>
                                                }
                                            </div>
                                            <div className="d-flex justify-content-between mb-4 prop-images">
                                                {
                                                    selectedEstate != null && selectedEstate.pictures != undefined && selectedEstate.pictures.length > 0 ? selectedEstate.pictures.map((item, i) => {
                                                        return (
                                                            <img src={item.urlLarge} alt="" className="room-image me-2" key={i} />
                                                        )
                                                    })
                                                        :
                                                        <></>
                                                }
                                            </div>
                                            <div className="form-container mb-4">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h4 className="heading">{selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingEstateDescription"] : "Description"}</h4>
                                                    {
                                                        whiseOffice != null && whiseOffice.website != undefined ?
                                                            <a href={whiseOffice.website} className="url-link" target="_blank">{whiseOffice.website}</a>
                                                            :
                                                            <></>
                                                    }
                                                </div>
                                                <p className="text-paragraph">
                                                    {
                                                        selectedEstate != null && selectedEstate.shortDescription != undefined && selectedEstate.shortDescription.length > 0
                                                            ?
                                                            selectedEstate.shortDescription.map((item, i) => {
                                                                const markup = { __html: item.content };
                                                                return (
                                                                    <p className="mb-0" dangerouslySetInnerHTML={markup} key={i}></p>
                                                                )
                                                            })
                                                            :
                                                            ""
                                                    }
                                                </p>
                                            </div>
                                            <div className="form-container">
                                                {
                                                    mapUrl != "" ?
                                                        <iframe
                                                            width="100%"
                                                            height="420px"
                                                            src={mapUrl}
                                                            title="Streets"
                                                        ></iframe>
                                                        :
                                                        <></>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div></div>
                        }
                    </>
            }

            {
                iframe == "iframe" ? <></> : <Footer />
            }
            {/* checkEstateStatusInDB={checkEstateStatusInDB} */}
            <EventModal showModal={showModal} handleClose={handleClose} clientToken={clientToken} eventSlot={selectedSlot}
                estate={selectedEstate} getAction={getAction} callbackGetToBeConfirmedIds={getToBeConfirmedIds}
                calendarActions={calendarActions} parent={getOfficeSettings} resetSelectedSlot={handlerResetSelectedSlot}
                officeId={getOfficeId} clientId={getClientId} clientSettings={clientSettings} time={time} formStep={formStep}
                setFormStep={setFormStep} prevSelectedEventSlot={prevSelectedEventSlot} selectedLanguage={selectedLanguage}
                selectedLanguageTranslations={selectedLanguageTranslations} agentLanguageTranslation={agentLanguageTranslation}
                officeLogoUrl={officeLogoUrl} officeSetting={officeSetting} whiseOffice={whiseOffice} queryParams={queryParams}
                contactTitles={contactTitles} formattedDate={formattedDate} freeSlotNotAvailable={freeSlotNotAvailable}
                checkEstateStatusInDB={bookingStatusForModal} contactId={contactId} waitingListContactDetail={waitingListContactDetail}
                iframe={iframe} setAgentLanguageTranslation={setAgentLanguageTranslation} translationsForAllLanguages={translationsForAllLanguages}
                isAutomaticSlotAccept={isAutomaticSlotAccept}
            />
        </>
    )
}